"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Contact = void 0;

var react_1 = __importDefault(require("react"));

var Typography_1 = require("./Typography");

var Contact = function Contact(_ref) {
  var name = _ref.name,
      email = _ref.email;
  if (!name) return null;
  var emailContent = email ? react_1.default.createElement(Typography_1.BodySmall, null, react_1.default.createElement("a", {
    href: "mailto:".concat(email)
  }, email)) : null;
  var nameContent = react_1.default.createElement(Typography_1.Body, null, name);
  return react_1.default.createElement(react_1.default.Fragment, null, nameContent, emailContent);
};

exports.Contact = Contact;